import Layers from "slotworks/graphics/layers/layers";
import regulationsModel from "slotworks/model/regulations/regulations-model";
import SpinControl from "slotworks/smart-ui/controls/spin/spin-control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class GoldenRockSpinControl extends SpinControl {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        if (!regulationsModel.skipAllowed) {
            this.button.setEnabled(false);
            this.button.setVisible(false);
        }
    }
}
